"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SecondTitle = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("h3", { className: styles_module_scss_1.default.slideSecondTitle }, children);
};
exports.default = SecondTitle;
